export const loading = (state) => state.loading;
export const valerrors = (state) => state.valerrors;
export const flashBanner = (state) => state.flashBanner;
